import jQuery from 'jquery';

;(function ( $, window, document, undefined ) {

    var pluginName = "googlemapsManager";
    var defaults = {
        lon : 5.104807599999958,
        lat : 52.0575802,
        zoom: 17,
        placemarkeroninit : false,
        showDebug : false
    };

    function GoogleMap (manager,$map) {
      this.manager = manager;
      this.$map = $map;
      this.map;
      this.marker = null;

      this.init();
    }

    $.extend(GoogleMap.prototype, {
      init: function () {
        var _this = this;

        var latLng = new google.maps.LatLng( 52.0575802, 5.104807599999958 );

        var options = {
          center: latLng,
          zoom: this.manager.settings.zoom
        };

        this.map = new google.maps.Map( this.$map[0], options );

        if(this.manager.settings.placemarkeroninit){
          this.initmarker();
          this.marker.setPosition( latLng );
        }

      },
      initmarker : function() {

        var customIcon = {
            path: 'M0-25c-5.9,0-10.7,4.8-10.7,10.7C-10.7-8.4,0,0,0,0s10.7-8.4,10.7-14.3C10.7-20.2,5.9-25,0-25z M0-7.9 c-3.5,0-6.4-2.9-6.4-6.4s2.9-6.4,6.4-6.4s6.4,2.9,6.4,6.4S3.6-7.9,0-7.9z',
            fillColor: '#f58f1e',
            fillOpacity: 1,
            scale: 1,
            strokeWeight: 0
        };

        var options = {
          map: this.map,
          icon : customIcon,
          draggable: false
        };

        if(this.marker==null){
          this.marker = new google.maps.Marker( options );
        }

      },
      setmarkerposition : function(lat,lon){

        if(this.marker==null){
          this.initmarker();
        }

        var latLng = new google.maps.LatLng( lat, lon );
        this.marker.setPosition( latLng );

        this.map.setCenter( latLng );
        this.map.setZoom( this.manager.settings.zoom );

        var mapCenter = this.map.getCenter();
        google.maps.event.trigger(this.map, 'resize');
        this.map.setCenter(mapCenter);


      },
      initautocomplete : function($field){

        if(this.marker==null) this.initmarker();

        var _map = this.map;
        var _marker = this.marker;
        var _this = this;

        var autocomplete = new google.maps.places.Autocomplete( $field[0] );
        autocomplete.bindTo( 'bounds', _map );

        google.maps.event.addListener( autocomplete, 'place_changed', function() {

          var place = autocomplete.getPlace();
          if ( ! place.geometry ) {
            return;
          }

          _map.setCenter( place.geometry.location );
          _map.setZoom( _this.manager.settings.zoom );

          _marker.setPosition( place.geometry.location );

          _this.$map.trigger('zmpcm_googlemaps_place_changed',[place.geometry.location.lat(),place.geometry.location.lng()]);

          var mapCenter = _map.getCenter();
          google.maps.event.trigger(_map, 'resize');
          _map.setCenter(mapCenter);

        });

        $field.keypress( function( event ) {
          if ( 13 === event.keyCode ) {
            event.preventDefault();
          }
        });

      },
      show : function(){
        var _this = this;

      }
    });

    function GoogleMapsManager ( element, options ) {
      var _this = this;
      this.element = element;
      this.$element = $(this.element);
      this.settings = $.extend( {}, defaults, options );
      this._defaults = defaults;
      this._name = pluginName;


      this.init();
    }

    $.extend(GoogleMapsManager.prototype, {
      init: function () {
        var _this = this;


      },
      createMap : function($el){
        var _this = this;

        return new GoogleMap(this,$el);
      },
      destroy : function(){
        this.$element.empty();
        this.$element.data("plugin_"+pluginName,null);
        //delete this;
      },
      logmessage: function(message){
        if(this.settings.showDebug) console.log(message);
      }
    });

    $.fn[ pluginName ] = function ( methodOrOptions ) {

      var method = (typeof methodOrOptions === 'string') ? methodOrOptions : undefined;

      if (method) {
          var customPlugins: Array<any> = [];

          const getCustomPlugin = () => {
              var $el          = $(this);
              var customPlugin = $el.data("plugin_"+pluginName);

              customPlugins.push(customPlugin);
          }

          this.each(getCustomPlugin);

          var args    = (arguments.length > 1) ? Array.prototype.slice.call(arguments, 1) : undefined;
          var results: Array<any> = [];

          const applyMethod = (index) => {
              var customPlugin = customPlugins[index];

              if (!customPlugin) {
                  console.warn('$.customPlugin not instantiated yet');
                  console.info(this);
                  results.push(undefined);
                  return;
              }

              if (method && typeof customPlugin[method] === 'function') {
                  var result = customPlugin[method].apply(customPlugin, args);
                  results.push(result);
              } else {
                  console.warn('Method \'' + method + '\' not defined in $.customPlugin');
              }
          }

          this.each(applyMethod);

          return (results.length > 1) ? results : results[0];
      } else {
          var options = (typeof methodOrOptions === 'object') ? methodOrOptions : undefined;

          const init = () => {
              var $el          = $(this);
              var customPlugin = new GoogleMapsManager($el, options);

              $el.data("plugin_"+pluginName, customPlugin);
          }

          return this.each(init);
      }


    };

})( jQuery, window, document );

